module.exports = __webpack_public_path__ + "img/Group508.146887a3.png";